import { z } from "zod";
import { InstitutionSchema } from "../gcl/index.js";

export default {
  params: z.object({
    accountId: z.string(),
  }),
  response: z.array(InstitutionSchema),
};
